"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _formik = require("formik");

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _styled = require("../styled");

var _InputHeader = _interopRequireDefault(require("../InputHeader"));

var _InputError = _interopRequireDefault(require("../InputError"));

var _InputHint = _interopRequireDefault(require("../InputHint"));

var _PostfixIconWrapper = _interopRequireDefault(require("../PostfixIconWrapper"));

var _Done = _interopRequireDefault(require("../../../../icons-react/Done"));

var _excluded = ["className", "name", "placeholder", "nativeInputProps", "header", "prependIcon", "isMobile", "hint", "onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Textarea = function Textarea(props) {
  var className = props.className,
      name = props.name,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      _props$nativeInputPro = props.nativeInputProps,
      nativeInputProps = _props$nativeInputPro === void 0 ? {} : _props$nativeInputPro,
      _props$header = props.header,
      header = _props$header === void 0 ? '' : _props$header,
      prependIcon = props.prependIcon,
      _props$isMobile = props.isMobile,
      isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
      hint = props.hint,
      onChange = props.onChange,
      formikRest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var _useField = (0, _formik.useField)(_objectSpread({
    name: name
  }, formikRest)),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 1),
      field = _useField2[0];

  var onChangeFormik = field.onChange,
      _onBlur = field.onBlur;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext.setFieldValue,
      errors = _useFormikContext.errors,
      touched = _useFormikContext.touched;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      focus = _React$useState2[0],
      setFocus = _React$useState2[1];

  var onChangeHandler = function onChangeHandler(e) {
    onChangeFormik(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    setFieldValue(name, e.target.value);
  };

  var hasError = Boolean(errors[name] && touched[name]);
  var styledProps = {
    hasError: hasError && !focus,
    hasTouched: Boolean(touched[name])
  };

  var inputProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, field), nativeInputProps), styledProps), {}, {
    id: name,
    name: name,
    placeholder: placeholder,
    onChange: onChangeHandler,
    onBlur: function onBlur(e) {
      setFocus(false);

      _onBlur(e);
    },
    onFocus: function onFocus() {
      return setFocus(true);
    }
  });

  var isCompleted = Boolean(!errors[name]) && Boolean(touched[name]) && Boolean(field.value);
  var isShowSuccessIcon = !focus && isCompleted;
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledInputContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_InputHeader["default"], {
    text: header,
    prependIcon: prependIcon,
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(StyledTextareaWrapper, styledProps, /*#__PURE__*/_react["default"].createElement(StyledTextarea, inputProps), isShowSuccessIcon && /*#__PURE__*/_react["default"].createElement(StyledPostfixIconWrapper, null, /*#__PURE__*/_react["default"].createElement(DoneStyled, null))), /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    name: name
  }), !(0, _isNil["default"])(hint) && !hasError && /*#__PURE__*/_react["default"].createElement(_InputHint["default"], null, hint));
};

var StyledPostfixIconWrapper = (0, _styledComponents["default"])(_PostfixIconWrapper["default"]).withConfig({
  displayName: "Textarea__StyledPostfixIconWrapper",
  componentId: "sc-15le6aj-0"
})(["position:absolute;right:8px;top:8px;padding:0;"]);

var StyledTextareaWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Textarea__StyledTextareaWrapper",
  componentId: "sc-15le6aj-1"
})(["position:relative;display:flex;flex-direction:row;align-items:flex-start;overflow:hidden;", " ", ";", ";"], _styled.InputStyles.Normal, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && _styled.InputStyles.Disabled;
}, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError && _styled.InputStyles.Error;
});

var StyledInputCSS = (0, _styledComponents.css)(["", " width:100%;height:112px;padding:16px 28px 16px 8px;::placeholder{", "}:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px white inset !important;}:focus{", "}"], _styled.InputStyles.Base, _styled.InputStyles.Placeholder, _styled.InputStyles.Focus);

var StyledTextarea = _styledComponents["default"].textarea.withConfig({
  displayName: "Textarea__StyledTextarea",
  componentId: "sc-15le6aj-2"
})(["", ""], StyledInputCSS);

var DoneStyled = (0, _styledComponents["default"])(_Done["default"]).withConfig({
  displayName: "Textarea__DoneStyled",
  componentId: "sc-15le6aj-3"
})(["path{stroke:#459e18;}"]);
var _default = Textarea;
exports["default"] = _default;